<template>
    <div class="google-map" id="map"></div>
</template>

<script async defer src="https://maps.googleapis.com/maps/api/js?key=AIzaSyC9OYTu-eCoyoAKfUsFabZx-k-yA_Wg8fw">
</script>
<script>
export default {
  props: {
    data: {
      type: String,
      required: true,
    },
  },
  name: "map",
  data() {
    return {
      map: null,
      lat: 25.047058,
      lng: 121.519752,
    };
  },
  mounted() {
    this.initMap();
  },
  methods: {
    // 建立地圖
    initMap() {
      const gps = this.data.split(",")
      let  myLatlng = { lat:25.047058 , lng: 121.519752 };


      if (gps.length===2){
         myLatlng = { lat:parseFloat(gps[0]) , lng: parseFloat(gps[1]) };
      }

      const map = new google.maps.Map(document.getElementById("map"), {
        zoom: 14,
        center: myLatlng,
      });

      this.$emit('mapData',map); 
      // Create the initial InfoWindow.
      let infoWindow = new google.maps.InfoWindow({
        content: "<div style='color:blue;font-weight:bold;'>點擊地圖查詢座標</div>",
        position: myLatlng,
      });

      infoWindow.open(map);
      // Configure the click listener.
      map.addListener("click", (mapsMouseEvent) => {

        // this.$emit(mapsMouseEvent.latLng); 
        // Close the current InfoWindow.
        infoWindow.close();
        // Create a new InfoWindow.
        infoWindow = new google.maps.InfoWindow({
          position: mapsMouseEvent.latLng,
        });
        infoWindow.setContent(
          "<div style='color:blue;font-weight:bold'>"+ mapsMouseEvent.latLng.toJSON().lat+","+mapsMouseEvent.latLng.toJSON().lng+"</div>",
        );
        infoWindow.open(map);
      });
    },
  },
};
</script>
<style scoped>

.google-map {
  margin-top: 40px;
  width: 95%;
  height: 400px;
}
</style>